const DB_NAME = "beyundai_research_chat_files_v1";
const STORE = "files";
const DB_VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error || new Error("Could not open attachment storage."));
  });
}

function txDone(tx) {
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error || new Error("Attachment storage transaction failed."));
    tx.onabort = () => reject(tx.error || new Error("Attachment storage transaction aborted."));
  });
}

/** Persist a File/Blob so it can be downloaded later. */
export async function saveResearchAttachment(id, file) {
  if (!id || !file) return;
  const db = await openDb();
  const buf = await file.arrayBuffer();
  const record = {
    id: String(id),
    name: String(file.name || "document"),
    mime: String(file.type || "application/octet-stream"),
    size: Number(file.size) || buf.byteLength,
    blob: new Blob([buf], { type: file.type || "application/octet-stream" }),
    savedAt: Date.now(),
  };
  const tx = db.transaction(STORE, "readwrite");
  tx.objectStore(STORE).put(record);
  await txDone(tx);
  db.close();
}

export async function getResearchAttachment(id) {
  if (!id) return null;
  const db = await openDb();
  const tx = db.transaction(STORE, "readonly");
  const req = tx.objectStore(STORE).get(String(id));
  const row = await new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error || new Error("Could not read attachment."));
  });
  await txDone(tx);
  db.close();
  return row;
}

export async function deleteResearchAttachment(id) {
  if (!id) return;
  const db = await openDb();
  const tx = db.transaction(STORE, "readwrite");
  tx.objectStore(STORE).delete(String(id));
  await txDone(tx);
  db.close();
}

export async function downloadResearchAttachment(id) {
  const row = await getResearchAttachment(id);
  if (!row?.blob) {
    throw new Error("Attachment file is not available for download.");
  }
  const url = URL.createObjectURL(row.blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = row.name || "document";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1500);
  return row.name;
}
